import { ProviderId } from "@indeed/signals-schema/com/indeed/signals/schema/reactnative/ProviderId";

const isProviderId = (v: string): v is ProviderId =>
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- RN-5783 baseline: pre-existing cast; migrate to zod/proper types (see docs/type-assertions.md)
  (Object.values(ProviderId) as string[]).includes(v);

export const getRnErrorProviderId = (provider: string): ProviderId => {
  return isProviderId(provider) ? provider : ProviderId.Unknown;
};
